import { render } from "./whois.vue?vue&type=template&id=2951ac77&ts=true"
import script from "./whois.vue?vue&type=script&lang=ts"
export * from "./whois.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__